import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getGuidanceService } from '../services/guidanceBookingService';
import analyticsService from '../services/analyticsService';

const cardStyle = {
  background: 'linear-gradient(135deg, rgba(16, 185, 129, 0.25), rgba(6, 182, 212, 0.25))',
  backdropFilter: 'blur(10px)',
  borderRadius: '16px',
  overflow: 'hidden',
  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
  border: '2px solid rgba(16, 185, 129, 0.5)',
  transition: 'all 0.3s ease',
  cursor: 'pointer',
  textDecoration: 'none',
  display: 'block',
  maxWidth: '360px',
};

const Connect = () => {
  const [offerings, setOfferings] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    getGuidanceService()
      .then((service) => {
        if (!cancelled) setOfferings([service]);
      })
      .catch(() => {
        if (!cancelled) setOfferings([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div
      style={{
        minHeight: '100vh',
        background: 'radial-gradient(ellipse at center, rgba(26, 26, 46, 0.8) 0%, rgba(22, 33, 62, 0.8) 50%, rgba(15, 15, 35, 0.9) 100%)',
        color: 'white',
        padding: window.innerWidth <= 768 ? '80px 16px 24px 16px' : '80px 24px 24px 24px',
      }}
    >
      <div style={{ textAlign: 'center', marginBottom: '20px', color: '#a7f3d0', fontSize: '15px', lineHeight: 1.9, letterSpacing: '0.5px' }}>
        <div>One Onda 🌊</div>
        <div>One Vibration ✨</div>
        <div>One Frequency 📡</div>
        <div>One Wave 🌊</div>
        <div>One Community 🤝</div>
      </div>

      <h1 style={{ textAlign: 'center', marginBottom: '12px', fontSize: '28px' }}>Connect</h1>
      <p style={{ textAlign: 'center', color: '#9ca3af', marginBottom: '32px' }}>
        Book time with us directly.
      </p>

      {loading && <p style={{ textAlign: 'center', color: '#22d3ee' }}>Loading…</p>}

      {!loading && offerings.length === 0 && (
        <p style={{ textAlign: 'center', color: '#9ca3af' }}>Nothing available right now — check back soon.</p>
      )}

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
          gap: '24px',
          maxWidth: '1200px',
          margin: '0 auto',
          justifyContent: 'center',
        }}
      >
        {offerings.map((service) => (
          <Link
            key={service.id}
            to="/guidance-call"
            style={cardStyle}
            onClick={() => {
              analyticsService.trackEvent('service_view', {
                serviceId: service.id,
                serviceName: service.name,
                source: 'connect',
              });
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.03)';
              e.currentTarget.style.boxShadow = '0 12px 40px rgba(16, 185, 129, 0.5)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
              e.currentTarget.style.boxShadow = '0 8px 32px rgba(0, 0, 0, 0.3)';
            }}
          >
            <div
              style={{
                width: '100%',
                aspectRatio: '4/3',
                background: 'linear-gradient(135deg, rgba(16, 185, 129, 0.4), rgba(6, 182, 212, 0.4))',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '3.5rem',
              }}
            >
              💬
            </div>
            <div style={{ padding: '20px' }}>
              <h3 style={{ margin: '0 0 8px', color: '#10b981' }}>{service.name}</h3>
              <p style={{ margin: '0 0 8px', color: '#4ade80', fontWeight: 700, fontSize: '1.1rem' }}>
                ${Number(service.price).toFixed(2)}
              </p>
              {(service.shortDescription || service.description) && (
                <p
                  style={{
                    color: '#9ca3af',
                    fontSize: '14px',
                    lineHeight: '1.5',
                    margin: 0,
                    display: '-webkit-box',
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                  }}
                >
                  {service.shortDescription || service.description}
                </p>
              )}
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Connect;
